
import React from 'react';

import NotifWrapper from './NotificationItem.style';

const NotificationItem = (props) => {
  const { comment, date, orderId, isRead, onClick, hideData } = props;
  const showComment = comment ? comment.substring(0, 78) + '..' : '';

  return (
    <NotifWrapper>
      <div
        onClick={() => onClick()}
        onKeyPress={() => onClick()}
        role="button"
        tabIndex={0}
        className={`NotifWrapper-item NotifWrapper-${isRead ? 'containerRead' : 'container'}`}
      >
        <div className="NotifWrapper-row">
          {!hideData && (
            <div className="NotifWrapper-date">
              <div className="NotifWrapper-date2">{date + ' - '}</div>
              <div className="NotifWrapper-id">{orderId}</div>
              <div className={`NotifWrapper-${isRead ? '' : 'dot'} `} />
            </div>
          )}
        </div>
        <div className="NotifWrapper-row">
          <div className={`NotifWrapper-${hideData ? 'menu' : 'comment'} `}>
            {comment && comment.length < 80 ? comment : showComment}
          </div>
        </div>
      </div>
    </NotifWrapper>
)};

export default NotificationItem;